import sourceItemConnector from "../source-item-connector"

import SourceEditItem from "./SourceEditItem"

export default sourceItemConnector(SourceEditItem)
